import React, { useState } from 'react'
import QuotationStatusList from './QuotationStatusList'
import { DataContext } from '../../../helper/HelperOne'
import NavBar from '../../nav_bar/Navbar'

function QuotationStatus() {
    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)

    return (

        <DataContext.Provider value={{searchUi, setSearchUi, searchData, setSearchData}}>
            <NavBar
                childrenPage={<QuotationStatusList/>}
                menuId={6}
            />
        </DataContext.Provider>
    )
}

export default QuotationStatus